export const multiValue = styles => ({
    ...styles,
    borderRadius: '4px',
    backgroundColor: '#6e7def',

});

export const multiValueRemove = styles => ({
    ...styles,
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
    backgroundColor: '#6e7def',
    color: '#fff',
    ':hover': {
        backgroundColor: '#332a54',
        color: '#fff',
    },
});

export const multiValueLabel = styles => ({
    ...styles,
    color: '#fff',
});
